import {
  useCallback, useEffect, useRef
} from 'react';

export const useFocusAndBlur = ({
  blurCallback,
  blurIsValid,
  ref: externalRef,
  shouldFocus = false,
  blurCallbackDelay = 0
} = {}) => {
  const internalRef = useRef();
  const ref = externalRef || internalRef;

  const onBlur = useCallback((e) => {
    const containsElement = ref.current && ref.current.contains(document.activeElement);

    if (blurCallback && !containsElement && (blurIsValid ? blurIsValid(e) : true)) {
      setTimeout(() => blurCallback(e), blurCallbackDelay);
    }
  }, [blurCallback, blurIsValid, ref, blurCallbackDelay]);

  const blur = useCallback(() => ref.current.blur(), [ref]);

  const focus = useCallback(() => ref.current.focus(), [ref]);

  useEffect(() => {
    if (shouldFocus) {
      focus();
    }
  }, [shouldFocus, focus]);

  return {
    onBlur,
    blur,
    focus,
    ref
  };
};

export default useFocusAndBlur;